import React from "react";
// import "./SuccessmodalStyle.css";

interface NonInsSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    message: string;
    onNav: () => void;
    password?: boolean;
    confirmPassword?: boolean;
    classicMobileIcon?: boolean;
}

const NonInsSuccessModal: React.FC<NonInsSuccessModalProps> = ({
    isOpen,
    onClose,
    message,
    onNav,
    password = false,
    confirmPassword = false,
    classicMobileIcon = false,
}) => {
    if (!isOpen) return null;

    return (
        <div className="success-modal-overlay">
            <div className="success-modal-container">
                {/* Glowing Checkmark Icon with Particles */}
                <div className="success-checkmark-container">
                    {/* Outer glow rings */}
                    <div className="success-glow-ring success-glow-ring-1"></div>
                    <div className="success-glow-ring success-glow-ring-2"></div>
                    <div className="success-glow-ring success-glow-ring-3"></div>

                    {/* Particle effects */}
                    <div className="success-particle success-particle-1">✦</div>
                    <div className="success-particle success-particle-2">✦</div>
                    <div className="success-particle success-particle-3">✦</div>
                    <div className="success-particle success-particle-4">✦</div>
                    <div className="success-particle success-particle-5">✦</div>
                    <div className="success-particle success-particle-6">✦</div>

                    {/* Main checkmark circle */}
                    <div className="success-checkmark-circle">
                        <svg
                            className="success-checkmark-icon"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5 13l4 4L19 7"
                                stroke="white"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h2 className="success-modal-title">Success!</h2>

                {/* Description */}
                <p
                    className="success-modal-description"
                    dangerouslySetInnerHTML={{ __html: message }}
                ></p>

                {/* Action Button */}
                <button className="success-dashboard-button" onClick={onNav}>
                    OK
                </button>

                {/* Optional Close Button for password/confirmPassword cases */}
                {(password || confirmPassword) && (
                    <button className="success-close-link" onClick={onClose}>
                        Close
                    </button>
                )}
            </div>
        </div>
    );
};

export default NonInsSuccessModal;